module.exports = __webpack_public_path__ + "static/media/2024-05-07-01.44a03f67.jpg";